import type { V3SchoolThroughSchoolAdminResponse } from "./queries.type";

export const v3SchoolThroughSchoolAdminMock: V3SchoolThroughSchoolAdminResponse =
  [
    {
      id: 11,
      unique_id: "bf9b8bcc7b914d05ba0aebc38eb3c7ee",
      name: "CIS 303 - Leadership and Community Service Academy",
      is_valid: null,
    },
    {
      id: 2000287767,
      unique_id: "7fe6f81adb8041c1a26c781014f6ae66",
      name: "NCE",
      is_valid: true,
    },
  ];
